<template>
  <div class="position-relative">
    <section class="section section-shaped my-0">
      <div class="shape shape-default">
      </div>
      <div class="container shape-container d-flex">
        <div class="col px-0">
          <div class="row">
            <div class="col-lg-6">
              <h1 class="display-3 text-white">合同誌・アンソロジー一覧
              </h1>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div v-for="item in Anthologies" :key="item.id">
      <section class="section section-lg">
        <div class="container pt-lg">
          <div class="row text-center justify-content-center">
            <div class="col-lg-10">
              <h2 class="display-3">{{ item.Name }}</h2>
              <p class="lead">{{ item.SubTitle }}</p>
              <h3>{{ item.Lead }}</h3>
            </div>
          </div>
          <div class="row row-grid align-items-center">
            <div class="col-md-8 order-md-1">
              <div class="pr-md-5">
                <p v-html="item.Description"></p>
              </div>
            </div>
            <div class="col-md-4 order-md-2">
              <img :src=item.ImageUrl class="img-fluid shadow">
            </div>
          </div>
          <hr>
          <div class="row row-grid align-items-center">
            <div class="col-md-8">
              <h4>書籍情報</h4>
              <div v-if="item.DisplayCPName != null">
                <h5>{{ item.DisplayCPName }}{{ item.Type }}</h5>
              </div>
              <div v-else>
                <h5>{{ item.MainCharacter }}{{ item.Type }}</h5>
              </div>
              <h5>サイズ：{{ item.Size }} {{ item.Pages }}P</h5>
              <h5 v-if="item.OtherAuthors['表紙']">表紙：{{ item.OtherAuthors['表紙'] }}</h5>
              <h5>発行日：{{ item.PublishDate }}（{{ item.EventName }}）</h5>
              <h5>価格：{{ item.Price }} 円（イベント頒布価格）</h5>
              <hr>
              <div class="btn-wrapper">
                  <span v-if="item.OnSaleWithPaper == true && item.OnlineStore">
                    <a :href="item.OnlineStore" target="_blank">
                      <base-button class="mb-3 mb-sm-0"
                                   outline type="warning"
                                   icon="ni ni-cart">
                        BOOTHで購入
                      </base-button>
                    </a>
                  </span>
                <span v-else-if="item.OnSaleWithPaper == true && !item.OnlineStore">
                    <base-button class="mb-3 mb-sm-0"
                                 outline type="warning"
                                 icon="fa-regular fa-clock" disabled>
                      BOOTH準備中
                    </base-button>
                  </span>
                <span v-else-if="item.OnSaleWithDigital == true">
                    <a :href="item.OnlineStore" target="_blank">
                      <base-button class="mb-3 mb-sm-0"
                                   outline type="warning"
                                   icon="ni ni-tablet-button">
                        BOOTHで購入(電子版)
                      </base-button>
                    </a>
                  </span>
                <span v-else>
                    <base-button class="mb-3 mb-sm-0"
                                 outline type="default" disabled
                                 icon="ni ni-fat-remove">
                      完売しました
                    </base-button>
                  </span>
              </div>
            </div>
            <div class="col-md-4">
              <div v-if="item.IsAnthology == true">
                <h4>参加者</h4>
                <BTable :items="item.OtherAuthors['参加者']"
                         :fields="['name', 'twitter', 'pixiv', 'web']"
                         thead-class="d-none" small>
                  <template #cell(name)="data">
                    <h5>{{ data.value }}</h5>
                  </template>
                  <template #cell(twitter)="data">
                    <a v-if="data.value" class="fa-brands fa-twitter-square fa-2xl" :href="data.value" target="_blank"></a>
                  </template>
                  <template #cell(pixiv)="data">
                    <a v-if="data.value" class="fa-brands fa-pixiv fa-2xl" :href="data.value" target="_blank"></a>
                  </template>
                  <template #cell(web)="data">
                    <a v-if="data.value" class="fa-solid fa-globe fa-2xl" :href="data.value" target="_blank"></a>
                  </template>
                </BTable>
              </div>
            </div>
          </div>
        </div>
     </section>
    </div>
  </div>
</template>
<script>
import { useHead } from '@vueuse/head'
import 'moment/locale/ja'
import moment from "moment";

export default {
  setup() {
    useHead({
      meta: [
        { property: 'og:title', content: '雛菊書房 - 合同誌・アンソロジー一覧' },
        { property: 'og:type', content: 'website' },
        { property: 'og:description', content: '小説二次創作中心同人小説サークル「雛菊書房」が発行している合同誌・アンソロジー一覧' },
        { property: 'og:image', content: location.origin + '/img/brand/default.png' },
        { property: 'twitter:card', content: 'summary' },
      ]
    })
  },
  name: "anthologies",
  components: {
    moment
  },
  data() {
    return{
      Anthologies: [],
      Events: []
    };
  },
  created() {
    moment.locale('ja')
    this.getEvents().then(() => {
      this.getBooks()
    })
  },
  methods: {
    getBooks() {
      this.axios.get('/strapi/api/book-informations?populate=%2A&sort[0]=PublishDate%3Adesc&filters[IsAnthology][$eq]=true')
        .then(response =>{
          this.Anthologies = response.data.data
          this.Anthologies.forEach(function (value, index, array){
            if(value['EventId'] !== null){
              if(this.Events.find(el => Number(el.EventId) == Number(value['EventId'])) != null) {
                array[index]['EventName'] = this.Events.find(el => el.EventId == value['EventId']).Name
                array[index]['EventInfo'] = this.Events.find(el => el.EventId == value['EventId'])
              }
            }
            switch (value['Size']){
              case 'Duodecimo':
                array[index]['Size'] = "四六判";
                break;
              case 'Paperback':
                array[index]['Size'] = "文庫";
                break;
              case 'Others':
                array[index]['Size'] = "その他";
                break;
              default:
                break;
            }
            switch (value['Type']){
              case 'Normal':
                array[index]['Type'] = "小説本";
                break;
              case 'Short':
                array[index]['Type'] = "短編小説本";
                break;
              case 'ShortStories':
                array[index]['Type'] = "短編集";
                break;
              case 'Series':
                array[index]['Type'] = "小説本(シリーズ)";
                break;
              case 'LongStory':
                array[index]['Type'] = "中長編小説本";
                break;
              case 'StoryAnthology':
                array[index]['Type'] = "小説合同誌・アンソロジー";
                break;
              case 'StoryComicsAnthology':
                array[index]['Type'] = "小説漫画合同誌・アンソロジー";
                break;
              case 'AllTypeAnthology':
                array[index]['Type'] = "合同誌・アンソロジー";
                break;
              case 'Others':
                array[index]['Type'] = value['OtherType'];
                break;
              default:
                break;
            }
            array[index]['PublishDate'] = moment(value['PublishDate']).format('YYYY/MM/DD')
            if (array[index]['Description'] !== null){
              array[index]['Description'] = value['Description'].replace(/\r?\n/g, '<br >');
            }
            if(array[index]['Image']){
              array[index]['ImageUrl'] = '/strapi' + value['Image']['formats']['small']['url']
            }
          }, this)
        }).catch(error =>{
          console.log(error)
      })
    },
    getEvents() {
      return this.axios.get('/strapi/api/event-informations?pagination[pageSize]=100')
          .then(response =>{
            this.Events = response.data.data
          }).catch(error =>{
        console.log(error)
      })
    },
  }
};
</script>
<style>
</style>
